module.exports = __webpack_public_path__ + "static/media/clock.6093ff0b.png";